<template lang="pug">
  nav
    ol
      li.item
        a(href="/static/logo-pack.zip" name="logo package") Logo pack
        //- router-link(to="{name: 'pageScene', params: {page: 'logo'}}") Logo
      li.item
        a(href="/static/visual-pack.zip" name="visuals package") Visuals pack
        //- router-link(to="{name: 'pageScene', params: {page: 'visuals'}}") Visuals
      li.item
        router-link(:to="{ name: 'backgrounds', params: {page: 'backgrounds'} }") Backgrounds
        //- router-link(to="{name: 'pageScene', params: {page: 'visuals'}}") Visuals
      li.item
        a(href="" name="styleguide").inactive Styleguide (coming soon)
        //- router-link(to="{name: 'pageScene', params: {page: 'styleguide'}}") Styleguide
</template>

<script>

import Vue from 'vue'

// component instance
var Navigation = Vue.component('navigation', {
  name: 'Navigation',
  props: ['payload'],
  data: function () {
    return {}
  },
  watch: {
  },
  methods: {

  },
  computed: {
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default Navigation
</script>

<style scoped>
  .image, img{
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue